import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';

const api = services.api;

// 发货单管理
export const FindSendOutPageLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/shippingOrderNew/findSendOutPage`;
        return api.post(params, config);
    },
};
